__turbopack_context__.v({
  "grid": "TX-lzG_grid",
  "header": "TX-lzG_header",
  "planCardAnchor": "TX-lzG_planCardAnchor",
  "shell": "TX-lzG_shell",
  "tabBar": "TX-lzG_tabBar",
  "tabItem": "TX-lzG_tabItem",
});
